/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function StandardNotification(props) {
    return (
        <SvgIcon {...props}>
            <circle cx="5" cy="7.5" r="5" />
        </SvgIcon>
    );
}

StandardNotification.defaultProps = {
    viewBox: '0 0 12 16'
};

export default StandardNotification;
